import axios from 'axios';
import { 
  Configuration, 
  GenerateDealsRequest, 
  GenerateDealsResponse,
  RedealRequest,
  RedealResponse,
  ValidationResponse, 
  SystemInfoResponse 
} from '../types';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Deal Generation
export const generateDeals = async (config: Configuration): Promise<GenerateDealsResponse> => {
  const request: GenerateDealsRequest = { config };
  const response = await api.post<GenerateDealsResponse>('/deals/generate', request);
  return response.data;
};

// Re-deal a single board using its original category settings
export const redealDeal = async (request: RedealRequest): Promise<RedealResponse> => {
  const response = await api.post<RedealResponse>('/deals/redeal', request);
  return response.data;
};

// Configuration Validation
export const validateConfiguration = async (config: Configuration): Promise<ValidationResponse> => {
  const response = await api.post<ValidationResponse>('/config/validate', config);
  return response.data;
};

// System Information
export const getSystemInfo = async (): Promise<SystemInfoResponse> => {
  const response = await api.get<SystemInfoResponse>('/system/info');
  return response.data;
};

// Health Check
export const healthCheck = async (): Promise<{ status: string; version: string }> => {
  const response = await api.get<{ status: string; version: string }>('/health');
  return response.data;
}; 